import { CSSProperties } from 'react';

import { FormLabel } from '@mui/material';

import { Flex } from 'src/components/Flex';
import { NPICurrencyInputProps } from 'src/components/inputs/NPICurrencyInput/NPICurrencyInput.types';

import { NPICurrencyInput } from './NPICurrencyInput';

interface NPICurrencyInputLabelledProps extends NPICurrencyInputProps {
    label: string;
    flexDirection?: CSSProperties['flexDirection'];
}

const NPICurrencyInputLabelled = ({
    label,
    flexDirection = 'column',
    ...inputProps
}: NPICurrencyInputLabelledProps) => {
    return (
        <Flex flexDirection={flexDirection} width="100px">
            <FormLabel sx={{ marginBottom: '8px', color: '#000', fontWeight: 600 }}>
                {label}
            </FormLabel>
            <NPICurrencyInput {...inputProps} />
        </Flex>
    );
};

export default NPICurrencyInputLabelled;
